import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './services.scss';
import InfoSection from '../components/infoSection';
import ServicesGrid from '../components/servicesGrid';
import Breadcrumb from '../common/Breadcrumb';
import { useTranslation } from 'react-i18next';

interface ServiceDetail {
  title: string;
  subheader?: string;
  body?: string;
  bodyParas?: string[];
}

const serviceKeys = ['freightCharter', 'timeCharter', 'shipyard', 'consulting'] as const;
const serviceIds = ['freight-charter', 'time-charter', 'shipyard', 'consulting'];

function Services() {
  const { t } = useTranslation();
  const location = useLocation();

  // Handle hash navigation on page load
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <div className='services-container'>
      <div className='main-content-container'>
        <Breadcrumb />
      </div>

      {/* Services Grid Section */}
      <div className='service-select-container'>
        <InfoSection title={t('services.title')}>
          <p className='text-content-container service-select-text'>
            {t('services.description')}
          </p>
          <ServicesGrid />
        </InfoSection>
      </div>

      {/* Service Detail Sections */}
      <div className='services-details-container'>
        {serviceKeys.map((key, index) => {
          const serviceDetail = t(`services.serviceDetails.${key}`, { returnObjects: true }) as ServiceDetail;
          return (
            <section key={serviceIds[index]} id={serviceIds[index]} className='service-section-wrapper'>
              <div className='main-content-container'>
                <div className='service-content-simple'>
                  <h2 className='service-title'>{serviceDetail.title}</h2>
                  {serviceDetail.subheader && (
                    <h3 className='service-subheader'>{serviceDetail.subheader}</h3>
                  )}
                  {serviceDetail.bodyParas ? (
                    serviceDetail.bodyParas.map((para, idx) => (
                      <p 
                        key={idx} 
                        className='service-body'
                        dangerouslySetInnerHTML={{ __html: para }}
                      />
                    ))
                  ) : (
                    <p 
                      className='service-body'
                      dangerouslySetInnerHTML={{ __html: serviceDetail.body || '' }}
                    />
                  )}
                </div>
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
}

export default Services;
